export default __webpack_public_path__ + "images/0x486b6fa0419b33a0c7a6e4698c231d7e2f2d5299.png";